import gql from "graphql-tag";

export const GET_RECOMMENDED_DOCTORS_LIST = gql`
  query GetDoctorList($filterInput: FilterDoctorInput) {
    getDoctorList(filterInput: $filterInput) {
      doctors
    }
  }
`;
